export class Client {
    id:number;
    name:string;
    associated_firm:number;
    gstnumber:string;
    type:string;
    deleted_at:string;
    created_at:string;
    updated_at:string;
}